<template>
	<div class="pt-2">
		<CommonFlame :title="'製造工程チェック'">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-btn
					color="primary"
					@click="$router.push({ name: 'check_sheet_show', params: { id: checkSheetId } })"
				>
					<v-icon class="mr-1">mdi-arrow-left-circle-outline</v-icon>
					チェックシート確認
				</v-btn>
			</template>
			<template v-if="$vuetify.breakpoint.xs">
				<v-row no-gutters justify="end">
					<v-btn
						class="mt-4"
						color="secondary"
						@click="$router.push({ name: 'check_sheet_show', params: { id: checkSheetId } })"
					>
						<v-icon class="mr-1">mdi-arrow-left-circle-outline</v-icon>
						チェックシート確認
					</v-btn>
				</v-row>
			</template>

			<p class="mt-2">作業対象者名：{{ user.full_name }}</p>
			<UserListDialog
				:checkProcess="check_process"
				:orderIndividualInfoId="order_individual_info.id"
			/>

			<v-row no-gutters align="center">
				<v-btn
					color="secondary"
					@click="startRequiredTime"
					class="mt-4 mr-2"
					:disabled="!authorized || disabledStartButton()"
				>
					<v-icon class="mr-1">mdi-timer-edit-outline</v-icon>
					開始 / 再開
				</v-btn>
				<v-btn
					color="red"
					:dark="authorized && !disabledStopButton()"
					@click="stopRequiredTime"
					class="mt-4 mr-2"
					:disabled="!authorized || disabledStopButton()"
				>
					<v-icon class="mr-1">mdi-timer-off-outline</v-icon>
					中断
				</v-btn>
				<ManufactureInfoDialog :id="order_individual_info.id" />
			</v-row>
			<h6 class="text-h6 mt-4 font-weight-bold">{{ customerCompanyName }}様向け</h6>
			<p class="text-body-2 mt-4">
				製造番号：{{
					order_individual_info
						? common.productNumberByOrderIndividualInfo(order_individual_info)
						: ""
				}}
				{{ checkSheetName }}
			</p>

			<CheckUnitsDialog
				:check_process="check_process"
				:checkSheetName="checkSheetName"
				:order_individual_info="order_individual_info"
				:editable="authorized && editable()"
			/>

			<v-divider class="my-4" />
			<template v-if="remainingQuantity">
				<p class="text-body-1 font-weight-bold">チェック結果入力</p>
				<v-form ref="form" v-model="valid">
					<v-menu
						ref="menu"
						close-on-content-click
						transition="scale-transition"
						offset-y
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								label="施工実施日(必須)"
								:rules="[rules.required]"
								v-model="check_unit.check_date"
								outlined
								dense
								readonly
								v-bind="attrs"
								v-on="on"
								class="mt-4"
							/>
						</template>
						<v-date-picker v-model="check_unit.check_date" no-title scrollable locale="ja" />
					</v-menu>
					<v-row no-gutters class="flex-nowrap">
						<v-text-field
							label="施工数量(必須)"
							v-model="check_unit.quantity"
							type="number"
							class="mt-4 append-outer"
							hide-spin-buttons
							outlined
							dense
							:rules="[
								rules.required,
								rules.moreThanZero,
								maxQuantity(check_unit.quantity, remainingQuantity),
							]"
						>
							<template v-slot:append>
								<v-btn icon class="mb-1 plus-minus-btn" @click="incrementQuantity"
									><v-icon>mdi-plus-circle-outline</v-icon></v-btn
								>
								<v-btn icon class="mb-1 plus-minus-btn" @click="decrementQuantity"
									><v-icon>mdi-minus-circle-outline</v-icon></v-btn
								>
							</template>
						</v-text-field>
						<div class="mt-4 pl-2 pt-2">
							/ {{ remainingQuantity }} (全数量:{{ order_individual_info.quantity }})
						</div>
					</v-row>

					<v-sheet v-if="check_process" elevation="0" class="mt-4">
						<p class="mt-4 font-weight-bold process-name">
							工程名：{{ check_process.check_process_type.name }}
						</p>
						<v-tabs v-model="tab" height="40px" class="mt-4" slider-color="primary" color="black">
							<v-tab v-for="(item, i) in check_process.check_process_type.check_items" :key="i">
								<template v-if="!checkForm(i)">
									<v-icon class="mr-1">mdi-check-circle</v-icon>
								</template>
								{{ item.name }}
							</v-tab>
						</v-tabs>
						<v-tabs-items v-model="tab" class="pa-2">
							<v-tab-item
								v-for="(item, i) in check_process.check_process_type.check_items"
								:key="i"
							>
								<table width="100%" class="mt-2 show-dialog-table">
									<tbody>
										<ShowDetailRecord :tdStyle="{ padding: '4px' }" :columnName="'チェック項目'">
											<template v-slot:value>
												({{ item.order_number }}/{{
													check_process.check_process_type.check_items.length
												}}) {{ item.name }}
											</template>
										</ShowDetailRecord>
										<ShowDetailRecord :tdStyle="{ padding: '4px' }" :columnName="'チェック方法'">
											<template v-slot:value>
												{{ item.check_method }}
											</template>
										</ShowDetailRecord>
										<ShowDetailRecord :tdStyle="{ padding: '4px' }" :columnName="'チェック基準'">
											<template v-slot:value>
												{{ item.standard }}
											</template>
										</ShowDetailRecord>
										<CheckValueForm
											:check_value.sync="check_unit.check_values_attributes[i]"
											:check_item="item"
										/>
									</tbody>
								</table>
							</v-tab-item>
						</v-tabs-items>

						<v-row class="mt-4" no-gutters justify="center">
							<v-btn color="secondary" @click="submitForm" :disabled="!valid || !checkData()">
								<v-icon class="mr-1">mdi-content-save-outline</v-icon>
								結果を保存
							</v-btn>
						</v-row>
					</v-sheet>
				</v-form>
			</template>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import rules from "../../helper/rules"
import CommonFlame from "../shared/CommonFlame.vue"
import ShowDetailRecord from "../shared/ShowDetailRecord.vue"
import ManufactureInfoDialog from "./components/ManufactureInfoDialog.vue"
import CheckUnitsDialog from "./components/CheckUnitsDialog.vue"
import CheckValueForm from "./components/CheckValueForm.vue"
import CheckValueEditDialog from "./components/CheckValueEditDialog.vue"
import UserListDialog from "./components/UserListDialog.vue"
import moment from "moment/min/moment.min.js"

export default {
	components: {
		CommonFlame,
		ShowDetailRecord,
		ManufactureInfoDialog,
		CheckUnitsDialog,
		CheckValueForm,
		CheckValueEditDialog,
		UserListDialog,
	},
	data() {
		return {
			id: this.$route.params.id,
			check_sheet_id: this.$route.query.check_sheet_id,
			tab: 0,
			order_individual_info: {},
			showResultForm: false,
			check_item: null,
			check_process: {
				check_process_type: {
					check_items: [],
				},
			},
			check_unit: {
				check_date: moment().format("YYYY-MM-DD"),
				quantity: null,
				check_values_attributes: [],
			},
			valid: false,
			customerCompanyName: "",
			checkSheet: {},
			checkSheetName: "",
			checkSheetId: "",
			authorized: false,
			manufactureInfoDialog: false,
			common,
			rules,
			confirmation: false,
			itemConfirmation: [],
			required_time: {
				end_date: null,
			},
			user: {},
		}
	},
	mounted() {
		this.fetchOrderIndividualInfo(true)
	},
	methods: {
		fetchOrderIndividualInfo(first_visit, check_date) {
			const headers = authenticate.setHeader()
			const params = { first_visit, check_sheet_id: this.check_sheet_id }
			const url = `/erp/v1/manufactures/order_individual_infos/${this.id}`

			axios
				.get(url, {
					params,
					headers,
				})
				.then((res) => {
					this.order_individual_info = res.data.order_individual_info
					this.check_process = res.data.check_process
					this.required_time = res.data.required_time
					this.check_unit.check_values_attributes = this.setKeyName()
					this.user = res.data.user
					if (check_date) {
						this.check_unit.check_date = check_date
					}
					if (first_visit) {
						this.authorized = res.data.authorized
						this.customerCompanyName = res.data.customer_company_name
						this.checkSheet = res.data.check_sheet
						this.checkSheetName = res.data.check_sheet.name
						this.checkSheetId = res.data.check_sheet.id
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		submitForm() {
			const headers = authenticate.setHeader()
			const params = {
				check_unit: this.check_unit,
				check_process_id: this.check_process.id,
				check_sheet_id: this.checkSheetId,
			}
			if (this.remainingQuantity == this.check_unit.quantity) {
				params.status = "complete"
			}
			const url = `/erp/v1/check_units`
			axios
				.post(url, params, {
					headers,
				})
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "保存しました",
					})
					this.resetForm()
					this.fetchOrderIndividualInfo(false, res.data.check_unit.check_date)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		startRequiredTime() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/manufactures/order_individual_infos/${this.id}`

			const params = { check_process_id: this.check_process.id }
			if (this.check_process.situation == "planned") {
				params.status = "start"
			} else if (this.check_process.situation == "ongoing") {
				params.status = "restart"
			}

			axios
				.put(url, params, {
					headers,
				})
				.then((res) => {
					if (res.data.status == "start") {
						this.$store.dispatch("setFlash", {
							type: "notice",
							text: "作業を開始しました",
						})
					} else if (res.data.status == "restart") {
						this.$store.dispatch("setFlash", {
							type: "notice",
							text: "作業を再開しました",
						})
					}
					this.check_process = res.data.check_process
					this.required_time = res.data.required_time
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		stopRequiredTime() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/manufactures/order_individual_infos/${this.id}`

			const params = {
				check_process_id: this.check_process.id,
				required_time_id: this.required_time.id,
			}
			params.status = "interruption"

			axios
				.put(url, params, {
					headers,
				})
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "作業を中断しました",
					})
					this.required_time = res.data.required_time
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		editable() {
			if (this.order_individual_info.status == "manufacture_completed") {
				return false
			} else {
				return true
			}
		},
		maxQuantity(value, remainingQuantity) {
			if (value > remainingQuantity) {
				this.open = false
				return `施工数量は${remainingQuantity}以下で入力してください`
			} else {
				return true
			}
		},

		incrementQuantity() {
			this.check_unit.quantity++
		},

		decrementQuantity() {
			if (this.check_unit.quantity == 0 || this.check_unit.quantity == null) return
			this.check_unit.quantity--
		},

		disabledStartButton() {
			return this.check_process.situation == "ongoing" && this.required_time?.end_date == null
		},
		disabledStopButton() {
			return (
				this.check_process.situation == "planned" ||
				(this.check_process.situation == "ongoing" && this.required_time?.end_date != null)
			)
		},

		checkData() {
			return this.check_unit.check_values_attributes.every((item) =>
				Object.values(item).every((value) => value !== null)
			)
		},
		resetForm() {
			this.itemConfirmation = []
			this.tab = 0
			this.$refs.form.reset()
		},
		setKeyName(column_id = "check_item_id") {
			let attributes = this.check_unit.check_values_attributes
				.map((attribute) => {
					if (attribute.id) {
						return { id: attribute.id }
					}
				})
				.filter((v) => !!v)

			const newAttributes = this.check_process.check_process_type.check_items.map((checkColumn) => {
				let checkValue = { [column_id]: checkColumn.id }
				checkValue[`value_${checkColumn.data_type}`] = null
				return checkValue
			})

			attributes = attributes.concat(newAttributes)
			return attributes
		},
		checkForm(i) {
			const obj = this.check_unit.check_values_attributes[i]
			return Object.values(obj).some(
				(value) => value === null || value === "" || (typeof value !== "boolean" && value <= 0)
			)
		},
	},
	computed: {
		remainingQuantity() {
			let quantity = this.check_process?.check_units?.reduce((sum, item) => {
				return sum + item.quantity
			}, 0)

			return this.order_individual_info.quantity - quantity
		},
	},
}
</script>

<style lang="scss" scoped>
.process-name {
	font-size: 1.2rem;
}
.plus-minus-btn {
	height: 30px;
}
</style>
